<template>
  <div class="PublicacionesReportes">
    <md-button @click.native="dialog_periodo = true">
      <md-icon>today</md-icon>
      Periodo del reporte
    </md-button>

    <div class="row">
      <div class="col-sm-6 m-b-24">
        <md-table
          v-model="visitas"
          md-sort="name"
          md-sort-order="asc"
          md-card
          md-fixed-header
        >
          <md-table-toolbar>
            <h1 class="md-title">Lecturas {{total_lecturas}}</h1>
          </md-table-toolbar>
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
          >
            <md-table-cell
              md-label="Publicación"
              md-sort-by="titulo_pub"
            >{{ item.titulo_pub }}</md-table-cell>
            <md-table-cell
              md-label="Lecturas"
              md-sort-by="lecturas"
              md-numeric
            >{{ item.lecturas }}</md-table-cell>
          </md-table-row>
        </md-table>
        <md-progress-bar
          md-mode="indeterminate"
          v-if="cargando_tabla"
        />
      </div>
      <div class="col-sm-6">
        <md-table
          v-model="descargas"
          md-sort="name"
          md-sort-order="asc"
          md-card
          md-fixed-header
        >
          <md-table-toolbar>
            <h1 class="md-title">Descargas {{total_descargas}}</h1>
          </md-table-toolbar>
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
          >
            <md-table-cell
              md-label="Publicación"
              md-sort-by="titulo_pub"
            >{{ item.titulo_pub }}</md-table-cell>
            <md-table-cell
              md-label="Archivo"
              md-sort-by="desc_par"
            >{{ item.desc_par }}</md-table-cell>
            <md-table-cell
              md-label="Descargas"
              md-sort-by="descargas"
              md-numeric
            >{{ item.descargas }}</md-table-cell>
          </md-table-row>
        </md-table>
        <md-progress-bar
          md-mode="indeterminate"
          v-if="cargando_tabla"
        />

      </div>
    </div>
    <md-dialog :md-active.sync="dialog_periodo">
      <md-dialog-title>Periodo</md-dialog-title>
      <md-dialog-content>
        <md-datepicker
          v-model="inicio"
          md-immediately
        >
          <label>Desde</label>
        </md-datepicker>
        <md-datepicker
          v-model="fin"
          md-immediately
        >
          <label>Hasta</label>
        </md-datepicker>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="dialog_periodo = false">Close</md-button>
        <md-button
          class="md-raised md-primary"
          @click.native="obtenerReporte()"
        >Consultar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { watchFile, watch } from "fs";

export default {
  name: "PublicacionesReportes",
  methods: {
    notificacion(a) {
      this.$parent.sb.texto = a;
      this.$parent.sb.mostrar = true;
    },
    obtenerReporte() {
      this.dialog_periodo = false;
      this.cargando_tabla = true;
      this.$http
        .post("reportes/visitasydescargas", {
          token: this.$session.get("token"),
          inicio: this.inicio
            ? moment(this.inicio).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD"),
          fin: this.fin
            ? moment(this.fin).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD")
        })
        .then(
          response => {
            this.cargando_tabla = false;
            if (response.status === 200 && "visitas" in response.body) {
              this.visitas = response.body.visitas;
              this.descargas = response.body.descargas;
            } else {
              this.notificacion(response.body.error);
            }
          },
          response => {
            this.cargando_tabla = false;
            this.notificacion(
              "No se pudo establecer conexión con el servidor para obtener los tipos de pruebas"
            );
          }
        );
    }
  },
  data() {
    return {
      dialog_periodo: false,
      inicio: null,
      termino: null,
      fin: null,
      visitas: [],
      descargas: [],
      cargando_tabla: false,
      total_lecturas: 0,
      total_descargas: 0
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerReporte();
  },
  watch: {
    visitas(a) {
      console.log("visitas counting");
      let b = 0;
      this.visitas.forEach(c => {
        b += parseInt(c.lecturas);
      });
      this.total_lecturas = b;
    },
    descargas(a) {
      console.log("descargas counting");
      let b = 0;
      this.descargas.forEach(c => {
        b += parseInt(c.descargas);
      });
      this.total_descargas = b;
    }
  }
};
</script>